import { motion } from "framer-motion";
import { LOGO_URL } from "@/lib/pricing";
import { scrollToId } from "@/lib/scroll";

export default function Nav() {
  return (
    <motion.header
      initial={{ y: -60, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1], delay: 0.2 }}
      className="fixed inset-x-0 top-0 z-40 border-b border-[#E5D8D3]/70 bg-[#FDFBF7]/85 backdrop-blur-xl"
      data-testid="site-nav"
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between px-5 py-3.5 lg:px-10">
        <button
          onClick={() => scrollToId("#top")}
          className="flex items-center gap-3 text-left"
          data-testid="nav-logo-button"
        >
          <img
            src={LOGO_URL}
            alt="Makie's Majestic Kreations logo"
            className="h-11 w-11 rounded-full object-cover ring-1 ring-[#D4AF37]/50"
          />
          <span className="leading-tight">
            <span className="ff-serif block text-lg italic">Makie&rsquo;s Majestic Kreations</span>
            <span className="block text-[9px] uppercase tracking-[0.32em] text-[#B08A2E]">
              Custom Apparel Atelier
            </span>
          </span>
        </button>
        <nav className="flex items-center gap-7">
          <button
            onClick={() => scrollToId("#collection")}
            className="hidden text-xs uppercase tracking-[0.22em] text-[#1A2421]/70 transition-colors hover:text-[#2A5C43] sm:block"
            data-testid="nav-collection-link"
          >
            Collection
          </button>
          <motion.button
            whileHover={{ scale: 1.03 }}
            whileTap={{ scale: 0.97 }}
            onClick={() => scrollToId("#order")}
            className="rounded-full bg-[#1A2421] px-6 py-2.5 text-xs uppercase tracking-[0.22em] text-[#FDFBF7] transition-colors hover:bg-[#2A5C43]"
            data-testid="nav-order-cta"
          >
            Start an Order
          </motion.button>
        </nav>
      </div>
    </motion.header>
  );
}
